import React, { memo } from "react";
import { RCCGrid, RCCSwitch } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";

const AdditionalPermissions: React.FC<{
    register: any;
    prefixNameInputs: string;
    permission: any;
	updatePermissions: (value: any, key: string) => void;
}> = ({
	permission,
	prefixNameInputs,
	register,
	updatePermissions
}) => {
	const {translate} = useTranslation();
	return (<>
		<RCCGrid container item xs={12} sm={6}>
			<RCCSwitch 
				name={`${prefixNameInputs}.ofp001Acessore`}
				register={register}
				label={translate("Receita de vendas")}
				defaultChecked={permission.ofp001Acessore === "S" || permission.ofp001Acessore === true}
				onChangeCapture={(e: any) => updatePermissions(e.target.checked, "ofp001Acessore")}
				labelPosition="end"
			/>
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6}>
			<RCCSwitch 
				name={`${prefixNameInputs}.ofp001Acessode`}
				register={register}
				label={translate("Dedução de vendas")}
				defaultChecked={permission.ofp001Acessode === "S" || permission.ofp001Acessode === true}
				onChangeCapture={(e: any) => updatePermissions(e.target.checked, "ofp001Acessode")}
				labelPosition="end"
			/>
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6}>
			<RCCSwitch 
				name={`${prefixNameInputs}.ofp001Acessocv`}
				register={register}
				label={translate("Custos variáveis")}
				defaultChecked={permission.ofp001Acessocv === "S" || permission.ofp001Acessocv === true}
				onChangeCapture={(e: any) => updatePermissions(e.target.checked, "ofp001Acessocv")}
				labelPosition="end"
			/>
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6}>
			<RCCSwitch 
				name={`${prefixNameInputs}.ofp001Acessodv`}
				register={register}
				label={translate("Despesas variáveis")}
				defaultChecked={permission.ofp001Acessodv === "S" || permission.ofp001Acessodv === true}
				onChangeCapture={(e: any) => updatePermissions(e.target.checked, "ofp001Acessodv")}
				labelPosition="end"
			/>
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6}>
			<RCCSwitch 
				name={`${prefixNameInputs}.ofp001Acessodo`}
				register={register}
				label={translate("Despesas operacionais")}
				defaultChecked={permission.ofp001Acessodo === "S" || permission.ofp001Acessodo === true}
				onChangeCapture={(e: any) => updatePermissions(e.target.checked, "ofp001Acessodo")}
				labelPosition="end"
			/>
		</RCCGrid>
		<RCCGrid container item xs={12} sm={6}>
			<RCCSwitch 
				name={`${prefixNameInputs}.ofp001Acessoou`}
				register={register}
				label={translate("Outras despesas")}
				defaultChecked={permission.ofp001Acessoou === "S" || permission.ofp001Acessoou === true}
				onChangeCapture={(e: any) => updatePermissions(e.target.checked, "ofp001Acessoou")}
				labelPosition="end"
			/>
		</RCCGrid>
	</>);
};

export default memo(AdditionalPermissions);
